//验证器
var errorCode = {
	code:{
		"1": "支付参数校验失败",
		"10": "通行证用户信息校验失败",
		"11": "系统错误/异常",
		"12": "用户被禁言",
		"201": "问题已经没有位置(空位)",
		"202": "问题已经回答完毕",
		"203": "存在已抢答但未完成的问题",
		"204": "用户未实名认证",
		"205": "用户账号被禁用",
		"206": "用户重复占位",
		"208": "还没有占座，不能提交回答",
		"209": "已经更新过，请不要重复更新",
		"401": "已经赞过",
		"501": "已经操作满意/不满意"
	},
	getError:function(code){
		if(this.code[code])
			return this.code[code];
		else
			return "errorCode:"+code;
	}	
}

module.exports = errorCode


//////////////////
// WEBPACK FOOTER
// ./src/module/helper/errorCode.js
// module id = 17
// module chunks = 0